import React, { useState } from 'react';
import { OnboardingStepProps } from '../../../types/onboarding';
import { StepTitle, StepDescription, StepContent } from '../../../styles/onboarding/Onboarding.styles';
import styled from 'styled-components';
import { theme } from '../../../styles/theme';

const TourContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.lg};
`;

const TourFeature = styled.div`
  padding: ${theme.spacing.lg};
  background: ${theme.colors.background.card};
  border-radius: ${theme.borderRadius.md};
  border: 1px solid ${theme.colors.border.light};
`;

const FeatureIcon = styled.div`
  font-size: 3rem;
  margin-bottom: ${theme.spacing.md};
  text-align: center;
`;

const FeatureTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: ${theme.colors.text.primary};
  margin: 0 0 ${theme.spacing.sm} 0;
`;

const FeatureDescription = styled.p`
  font-size: 1rem;
  color: ${theme.colors.text.secondary};
  margin: 0;
  line-height: 1.6;
`;

export const AppTourStep: React.FC<OnboardingStepProps> = ({
  onChange
}) => {
  const [appTourViewed, setAppTourViewed] = useState(false);

  React.useEffect(() => {
    setAppTourViewed(true);
    onChange({ appTourViewed: true }, true);
  }, []);

  return (
    <>
      <StepTitle>App Tour</StepTitle>
      <StepDescription>
        Learn about the key features that will help you find meaningful connections.
      </StepDescription>
      <StepContent>
        <TourContainer>
          <TourFeature>
            <FeatureIcon>💕</FeatureIcon>
            <FeatureTitle>Swipe & Match</FeatureTitle>
            <FeatureDescription>
              Swipe through profiles and match with people who interest you. Your matches will appear in your messages.
            </FeatureDescription>
          </TourFeature>

          <TourFeature>
            <FeatureIcon>💬</FeatureIcon>
            <FeatureTitle>Messaging</FeatureTitle>
            <FeatureDescription>
              Chat with your matches in real-time. Start meaningful conversations and build connections.
            </FeatureDescription>
          </TourFeature>

          <TourFeature>
            <FeatureIcon>📱</FeatureIcon>
            <FeatureTitle>Social Feed</FeatureTitle>
            <FeatureDescription>
              Discover moments and stories from people in your area. Engage with posts and connect with the community.
            </FeatureDescription>
          </TourFeature>

          <TourFeature>
            <FeatureIcon>👥</FeatureIcon>
            <FeatureTitle>Community Chat Rooms</FeatureTitle>
            <FeatureDescription>
              Join persona-based chat rooms to meet like-minded people and build meaningful connections.
            </FeatureDescription>
          </TourFeature>
        </TourContainer>
      </StepContent>
    </>
  );
};

